import { suggestionSourceLinkSchema } from "@redotech/shopper-agent-knowledge-common/suggested-merchant-knowledge-view";
import { suggestedMerchantKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

/**
 * The conversations that led the generator to propose a suggestion, shown to
 * the merchant as justification. A cited topic with no conversation a merchant
 * can open still comes back, so this list and the row's count agree.
 */
export const getSuggestionSources = {
  name: "getSuggestionSources" as const,
  input: z.object({ id: suggestedMerchantKnowledgeIdFormat.schema }),
  output: z.object({ sources: z.array(suggestionSourceLinkSchema) }),
};
